// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import PaymentMethodsController from "./payment_methods_controller";
import PaymentFormsController from "./payment_forms_controller";
import PolicyApplicationController from "./policy_application_controller";
import IncomeDetailsController from "./income_details_controller";
import VisibilityController from "./visibility_controller";
import BrainTreeController from "./braintree_cc_controller";
import StripeCcController from "./stripe_cc_controller";
import FormController from "./form_controller";
import BatchTransactionController from "./batch_transaction_controller";
import DirectUploadController from "./direct_upload_controller";
import DocVerifyController from "./doc_verify_controller";
import JavascriptRequiredController from "./javascript_required_controller";
import QuotesFormController from "./quotes_form_controller";
import AuAddressFieldsController from "./au_address_fields_controller";
import TooltipController from "./tooltip_controller";
import ComparisonTableController from "./comparison_table_controller";
import ExtensionRequestController from "./extension_request_controller";
import ResourceLoadController from "./resource_load_controller";
import ExtraItemsController from "./extra_items_controller";
import KeyFeaturesToggleController from "./key_features_toggle_controller";
import CancellationRequestController from "./cancellation_request_controller";
import CreditCardController from "./credit_card_controller";
import PopupModalController from "./popup_modal_controller";
import FormValidationController from "./form_validation_controller";
import BarFieldsController from "./bar_fields_controller";
import OtpResendController from "./otp_resend_controller";
import HistoryBackController from "./history_back_controller";

application.register("payment-methods", PaymentMethodsController);
application.register("payment-forms", PaymentFormsController);
application.register("policy-application", PolicyApplicationController);
application.register("income-details", IncomeDetailsController);
application.register("visibility", VisibilityController);
application.register("braintree-cc", BrainTreeController);
application.register("stripe-cc", StripeCcController);
application.register("form", FormController);
application.register("batch-transaction", BatchTransactionController);
application.register("direct-upload", DirectUploadController);
application.register("doc-verify", DocVerifyController);
application.register("javascript-required", JavascriptRequiredController);
application.register("quotes-form", QuotesFormController);
application.register("au-address-fields", AuAddressFieldsController);
application.register("tooltip", TooltipController);
application.register("comparison-table", ComparisonTableController);
application.register("extension-request", ExtensionRequestController);
application.register("resource-load", ResourceLoadController);
application.register("extra-items", ExtraItemsController);
application.register("key-features-toggle", KeyFeaturesToggleController);
application.register("cancellation-request", CancellationRequestController);
application.register("credit-card", CreditCardController);
application.register("popup-modal", PopupModalController);
application.register("form-validation", FormValidationController);
application.register("bar-fields", BarFieldsController);
application.register("otp-resend", OtpResendController);
application.register("history-back", HistoryBackController);
